export default __webpack_public_path__ + "static/media/heroImage.134d6803.jpg";